<template>
    <div class="c-a-checkbox" :class="{'c-a-checkbox--invalid' : invalid}">
        <input  class="c-a-checkbox__input" type="checkbox" :name="`checkbox-${id}`" :id="`checkbox-${id}`" value="1" v-model="selected" v-on:change="updated">
        <label class="c-a-checkbox__label" :for="`checkbox-${id}`">
            <span class="c-a-checkbox__box">
                <icon :icon="'check'" />
            </span>
            <span class="c-a-checkbox__text" v-html="labelActual"></span>
        </label>
    </div>
</template>

<script>
    import Icon from '../AtomIcon.vue';

    export default {
        props:{
            id: Number,
            label: String,
            question: String,
            invalid: Boolean,
            required: Boolean,
            dataKey: String,
            // ifall man vill ha en föribockad checkbox kan detta användas
            checked: Boolean,
        },
        data() {
            return{
                selected: this.checked
            }
        },
        components: {
            Icon
        },
        computed: {
            labelActual: function() {
                return this.required ? `${this.label} *` : this.label;
            }
        },
        methods:{
            updated(){
                const data = {
                    questionId: this.id,
                    label: this.label,
                    answers: this.selected ? true : false,
                    single: true
                };

                if(this.dataKey){
                    data.dataKey = this.dataKey;
                }

                this.$emit('updateData', data);
            }
        },
        mounted() {
            // om proppen 'checked' är true ska formen uppdateras automatiskt ifall värdet inte ändras av användaren
            if(this.checked) {
                this.updated();
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/views/components/atoms/request-form/AtomCheckboxRequestForm.vue